import { Typography } from "@heroui/react";
import { Icon } from "@iconify/react";

import { HERO } from "./constants";

import { AI_ASSISTANT } from "@/config/constants";
import { AppIcon } from "@/components/common/app-icon";

// Copy is white rather than `foreground`: this sits on a fixed image, so the
// semantic token would invert with the theme and disappear.
export const AuthShowcaseCard = () => (
  <div className="relative w-full max-w-sm">
    <div
      aria-hidden
      className="auth-media-panel absolute inset-0 -translate-y-3 translate-x-3 rotate-3 rounded-2xl opacity-50"
    />

    <div className="auth-media-panel relative flex flex-col gap-3 rounded-2xl p-4">
      <div className="flex items-center gap-2.5">
        <div className="flex size-9 flex-none items-center justify-center rounded-full bg-white/15">
          <Typography className="text-white" type="body-xs" weight="semibold">
            {HERO.showcase.initials}
          </Typography>
        </div>

        <div className="flex min-w-0 flex-1 flex-col">
          <Typography
            truncate
            className="text-white"
            type="body-sm"
            weight="semibold"
          >
            {HERO.showcase.name}
          </Typography>
          <Typography truncate className="text-white/60" type="body-xs">
            {HERO.showcase.subject} · with {HERO.showcase.assignee}
          </Typography>
        </div>

        <div className="flex flex-none items-center gap-1.5 rounded-full bg-white/15 px-2 py-1">
          <span className="size-1.5 rounded-full bg-success" />
          <Typography className="text-white" type="body-xs" weight="medium">
            {HERO.showcase.status}
          </Typography>
        </div>
      </div>

      <div className="h-px bg-white/15" />

      <div className="flex items-center gap-2 text-white/80">
        <Icon
          className="flex-none"
          icon="solar:calendar-mark-linear"
          width={16}
        />
        <Typography className="text-current" type="body-xs">
          {HERO.showcase.when}
        </Typography>
      </div>

      {/* Its own hairline keeps the agent line reading as attribution rather
      than a fourth field of the booking. */}
      <div className="h-px bg-white/10" />

      <div className="flex items-center gap-2 text-white/65">
        <AppIcon className="flex-none" icon={AI_ASSISTANT.icon} width={14} />
        <Typography className="text-current" type="body-xs">
          {HERO.showcase.source}
        </Typography>
      </div>
    </div>
  </div>
);
